export const noticeExtractionFailedStates = new Set([
  'FAILED',
  'TERMINATED',
  'CANCELED',
  'CANCELLED',
  'TIMED_OUT',
  'ERROR',
]);

const MAX_CONSECUTIVE_POLL_FAILURES = 4;
const STALL_TIMEOUT_MS = 15 * 60 * 1000;

export type TNoticeExtractionPollFailure = 'extraction' | 'status-unavailable' | 'stalled';

export type TNoticeExtractionPollInput = {
  attachmentExtracted?: boolean;
  workflowState?: string;
  consecutiveFailures: number;
  elapsedMs: number;
};

export type TNoticeExtractionPollOutcome =
  | { kind: 'completed' }
  | { kind: 'failed'; status: string; failure: TNoticeExtractionPollFailure }
  | { kind: 'continue' };

export const resolveNoticeExtractionPollOutcome = (input: TNoticeExtractionPollInput): TNoticeExtractionPollOutcome => {
  if (input.attachmentExtracted || input.workflowState === 'COMPLETED') {
    return { kind: 'completed' };
  }

  if (input.workflowState && noticeExtractionFailedStates.has(input.workflowState)) {
    return { kind: 'failed', status: input.workflowState, failure: 'extraction' };
  }

  if (input.consecutiveFailures >= MAX_CONSECUTIVE_POLL_FAILURES) {
    return { kind: 'failed', status: 'ERROR', failure: 'status-unavailable' };
  }

  if (input.elapsedMs >= STALL_TIMEOUT_MS) {
    return { kind: 'failed', status: 'ERROR', failure: 'stalled' };
  }

  return { kind: 'continue' };
};
